module.exports = __webpack_public_path__ + "static/media/text.eb3d0760.svg";